/* RESPONSIBLE TEAM: team-standalone */

import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class SalesforceCasesConnectController extends Controller {
  queryParams = ['section', 'errorCode'];

  @tracked declare section: string | null;
  @tracked declare errorCode?: string;

  @action
  setSection(section: string | null) {
    this.section = section;
  }
}

declare module '@ember/controller' {
  interface Registry {
    '/apps/app/standalone/deploy/salesforce/cases/connect': SalesforceCasesConnectController;
  }
}
